import { mergeStyles } from '@cian/utils';
import { InlineText2, InlineText3 } from '@cian/ui-kit/typography/InlineText';

import * as React from 'react';

import * as styles from './CustomFormField.css';
import { ICustomFormFieldProps } from './types';

export const CustomFormField: React.FC<ICustomFormFieldProps> = props => {
  const { label, children, containerClassName, errorMessage, required = false } = props;

  return (
    <div className={mergeStyles(styles['container'], containerClassName).className}>
      <div className={mergeStyles(styles['label-container'], required && styles['required']).className}>
        <InlineText2 as="span" color="black_100" fontWeight="normal">
          {label}
        </InlineText2>
      </div>
      {children}
      <div className={styles['error-message-container']}>
        <InlineText3 as="span" color="error_100" fontWeight="normal">
          {errorMessage}
        </InlineText3>
      </div>
    </div>
  );
};

CustomFormField.displayName = 'CustomFormField';
